import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsPassOnLogService} from '../../../services/settings-pass-on-log.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-pass-on-log-detailed-view',
    templateUrl: './settings-pass-on-log-detailed-view.component.html',
    styleUrls: ['./settings-pass-on-log-detailed-view.component.scss']
})

export class SettingsPassOnLogDetailedViewComponent {
    title = 'Resident';
    disabledFileInput = false;
    navPosition = 'general';
    attachments: Array<any> = [];
    selectValues = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    noEdit = false;

    constructor(public api: ApiClientService,
                public settingsPassOnLogService: SettingsPassOnLogService,
                public directoryService: DirectoryService) {
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/settings/${this.settingsPassOnLogService.selectedItemData.id}.json`;
        this.settingsPassOnLogService.api.patch('domainPassOnLog', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => {
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.forEach(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        // (<any>this.settingsPassOnLogService.selectedItemData).name = this.settingsPassOnLogService.selectedItemData.corporationNumberName;
        // this.settingsPassOnLogService.getSettingsForCorporation(this.settingsPassOnLogService.selectedItemData.corporationNumberBdId);
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            this.onSubmit(valueToSend);
        }
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsPassOnLogService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    showNotificationModal(staffOrResident, notificationType): void {
        // this.settingsPassOnLogService.isNotificationModalShow = true;
        // this.settingsPassOnLogService.notificationModalStaffOrResident = staffOrResident;
        // this.settingsPassOnLogService.notificationModalNotificationType = notificationType;
    }

    submitNotificationsField(): void {
        const data = {staffNotificationSettings : [
                {
                    action: 'created',
                    enableStatus: this.settingsPassOnLogService.passCreatedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsPassOnLogService.createdStaffMultiselectArray)
                },
                {
                    action: 'read',
                    enableStatus: this.settingsPassOnLogService.passReadStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsPassOnLogService.readStaffMultiselectArray)
                },
                {
                    action: 'updated',
                    enableStatus: this.settingsPassOnLogService.passUpdatedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsPassOnLogService.updatedStaffMultiselectArray)
                },
                {
                    action: 'deleted',
                    enableStatus: this.settingsPassOnLogService.passDeletedStaffCheckbox ? 1 : 0,
                    userRoles: this.getUserRolesFormatted(this.settingsPassOnLogService.deletedStaffMultiselectArray)
                }
            ]
        };
        this.onSubmit(data);
    }

    getUserRolesFormatted(arr): Array<any> {
        return arr.map(a => ({bdId: a.id, roleName: a.itemName}));
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    emailTemplateIsSet(type, action) {
        let flag = false;
        // this.settingsPassOnLogService.selectedItemData[type + 'NotificationSettings'].filter((setting) => {
        //     if(setting.action == action)
        //         flag = setting.emailTemplate === null && !setting.emailTemplateOtherMessage && !setting.emailTemplateOtherSubject ? false : true;
        // });
        return flag;
    }

    submitPopupRoles(value) {
        const data = {
            showPopupUponDashboard: {
                roles: value.map(v => ({bdId: v.id, name: v.itemName}))
            }
        };
        this.onSubmit(data);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log-detailed-view/settings-pass-on-log-detailed-view.component.ts